<template>
    <div id="app" style="text-align:center; margin-top:50px;">
        <h1>Telegram Web App 抽奖</h1>
        <div v-if="!hasDrawn">
            <button @click="drawPrize">抽奖</button>
        </div>
        <div v-else>
            <h2>🎉 你抽中了：{{ prize }} 🎉</h2>
            <button @click="resetLottery">重置抽奖</button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const hasDrawn = computed(() => store.state.hasDrawn)
const prize = computed(() => store.state.prize)

const drawPrize = () => {
    // 这里模拟抽奖逻辑
    const prizes = ['🎁 小礼物', '🎉 大礼包', '🍎 苹果', '📱 iPad']
    const rand = Math.floor(Math.random() * prizes.length)
    store.commit('setPrize', prizes[rand])
}

const resetLottery = () => {
    store.commit('reset')
}

// Telegram Web App 初始化
if (window.Telegram?.WebApp) {
    const tg = window.Telegram.WebApp
    tg.ready()
    tg.expand()
    console.log('Telegram 用户信息:', tg.initDataUnsafe.user)
}
</script>
